import React from "react";
import { useNavigate } from "react-router-dom";

const BackButton = (props) => {
    const navigate = useNavigate();

    return (
        <button
            className="btn btn-outline-primary"
            onClick={() => navigate(props.returnPath)}
        >
            <i className="bi bi-arrow-left-square" /> Back
        </button>
    );
};

export default BackButton;
